// extracted by mini-css-extract-plugin
export default {"table":"CopyModal_table__7JUxe"};